export enum EyefinityDashboardStatusTypeEnum {
  newSignup,
  pendingSignup,
  omiManage,
  epmManage,
}
